import angular, * as regular from 'angular';
import { adminExperienceDashboardComponent } from './admin-experience-dashboard.component';
import { topLevelAdminExperienceComponent } from './top-level-admin-experience.component';


export const AdminExperienceModule = angular.module('adminExperienceModule', [])
  .component('topLevelAdminExperiences', topLevelAdminExperienceComponent)
  .component('adminExperiencesDashboard', adminExperienceDashboardComponent)
  .name;
